import { qualifyUrls } from 'routing/Routes';
import AppConfig from 'util/AppConfig';

const CrowdStrikeRoutes = {
  INTEGRATIONS: {
    CrowdStrike: {
      ACTIVITYAPI: {
        index: '/integrations/crowdstrike',
      },
    },
  },
};

const ApiRoutes = {
  INTEGRATIONS: {
    CrowdStrike: {
      SAVE_INPUT: '/plugins/org.graylog.enterprise.integrations/crowdstrike/inputs',
      CHECK_CREDENTIALS: '/plugins/org.graylog.enterprise.integrations/crowdstrike/checkCredentials',

    },
  },
};

const DocsRoutes = {
  INTEGRATIONS: {
    CrowdStrike: {
      GRAYLOG_CrowdStrike_ACTIVITY_LOG_INPUT: 'integrations/inputs/graylog_crowdstrike_ActivityLog_Input.html#graylog-crowdstrike-activitylog-input',
    },
  },
};

const qualifiedRoutes = AppConfig.gl2AppPathPrefix() ? qualifyUrls(CrowdStrikeRoutes, AppConfig.gl2AppPathPrefix()) : CrowdStrikeRoutes;

export default {
  ...qualifiedRoutes,
  unqualified: CrowdStrikeRoutes,
};

export { DocsRoutes, ApiRoutes };
